export const ProfileRoutes = {
    getProfile: "/user/getUser",
    updateProfile :"/auth/updateUser",
  };
  